import React from "react";

import { graphql } from "gatsby";

import {
  Container,
  Content,
  Description,
  Link,
  LinksContainer,
  Message,
} from "./MicrosoftStatementBlock.styles";

export interface MicrosoftStatementBlockProps
  extends Queries.SanityMicrosoftStatementBlock {}

const MicrosoftStatementBlock: React.FC<MicrosoftStatementBlockProps> = () => (
  <Container>
    <Content>
      <Message>
        <Description>
          This site is jointly operated by Microsoft and Uizard, and both
          companies are committed to protecting your privacy. Any personal data
          we collect from you on this site may be shared between Microsoft and
          Uizard. For complete information on the data collection and use
          practices of each company, please read the full privacy statements by
          clicking on the links below.
        </Description>
        <LinksContainer>
          <Link
            href="https://privacy.microsoft.com/en-us/privacystatement"
            target="_blank"
            rel="noopener noreferrer"
          >
            Microsoft Privacy Statement
          </Link>
          <Link href="/privacy/">Uizard Privacy Policy</Link>
        </LinksContainer>
      </Message>
    </Content>
  </Container>
);

export const query = graphql`
  fragment MicrosoftStatementBlock on SanityMicrosoftStatementBlock {
    _key
    _type
    description
  }
`;

export default MicrosoftStatementBlock;
